import React from "react";
import styled from "styled-components";
import { rem } from "polished";

import CloseButton from "./CloseButton";

import mq from "../../helpers/media-queries";

const Container = styled.div`
    height: 100%;
    background: #fff;
    border-radius: 20px;
    overflow: hidden;
    position: relative;
`;

const InnerTextContainer = styled.div`
    overflow: scroll;
    height: 100%;
    position: relative;

    ${mq("sm", "max")} {
        padding: ${rem(27.5)};
        padding-top: ${rem(60)};
    }

    ${mq("sm", "min")} {
        padding: ${rem(55)};
        padding-top: ${rem(120)};
        display: flex;
        justify-content: space-between;
    }

    iframe {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        width: 100% !important;
        height: 100% !important;
    }
`;

const Column = styled.div`
    ${mq("sm", "min")} {
        padding-right: ${rem(25)};
        width: ${rem(150)};
    }
`;

const Video = ({ closeModal, videoUrl }) => (
    <Container>
        <CloseButton closeModal={closeModal} />

        <InnerTextContainer>
            <iframe
                width="400"
                height="315"
                src={videoUrl}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ width: "100%", height: "100%" }}
            ></iframe>
        </InnerTextContainer>
    </Container>
);

export default Video;
